import { render, staticRenderFns } from "./ChangguanHotStatBlock.vue?vue&type=template&id=628fb5d7&scoped=true"
import script from "./ChangguanHotStatBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanHotStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ChangguanHotStatBlock.vue?vue&type=style&index=0&id=628fb5d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fb5d7",
  null
  
)

export default component.exports